export default "__VITE_ASSET__qMlvoBtV__"